<template>
<div>
  <b-row>
    <b-col>
      <div class="btn-group">
        <router-link tag="button" :to="{ name: 'EXABPackagesUpdate', params: { id: $route.params.id } }" class="btn btn-sm btn-default float-left mb-2">{{$t('buttons.edit')}}</router-link>
      </div>
      <router-link :to="{ name: 'EXABPackagesList' }" class="btn btn-sm btn-default float-right mb-2">{{$t('buttons.backToList')}}</router-link>
    </b-col>
  </b-row>
  <Loader v-if="isLoading"></Loader>
  <b-row v-else>
    <b-col md="12" lg="6">
        <b-card>
          <div>
            <h6>
              <i class="fa fa-file fa-lg"></i>
              {{$t("views.packages.show.package")}}:
            </h6>
            <hr class="mb-1 mt-0">
          </div>
          <div>
            <p v-if="item.name">{{$t('views.exsbitemscategories.form.name')}}:
              <b>{{ item.name }}</b>
            </p>
            <p v-if="item.description">{{$t('views.exsbitemscategories.form.description')}}:
              <b>{{ item.description }}</b>
            </p>
            <p v-if="item.dateFrom">{{$t('views.agreements.form.dateFrom')}}:
              <b>{{ $moment(item.dateFrom).format('YYYY-MM-DD') }} </b>
            </p>
            <p v-if="item.dateTo">{{$t('views.agreements.form.dateTo')}}:
              <b>{{ $moment(item.dateTo).format('YYYY-MM-DD') }} </b>
            </p>
          </div>
        </b-card>
        <b-card v-if="item.packageItems.length > 0">
          <div>
            <h6>
              <i class="fa fa-cog fa-lg"></i>
              {{$t('views.exsbitems.list.title')}}:
            </h6>
            <hr class="mb-1 mt-0">
          </div>
          <div>
            <table class="table table-responsive-md table-sm table-grid">
              <thead>
              <tr>
                <th style="width: 5%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
                </th>
                <th style="width: 20%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
                </th>
                <th style="width: 20%"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in item.packageItems" :key="item['@id']">
                <td>{{ index + 1 }}</td>
                <td>
                  <router-link
                    v-if="ableToViewItem"
                    :to="{name: 'EXSBItemShow', params: {id: item.item['@id']}}">
                    {{ item.item.name }}
                  </router-link>
                  <span v-else>
                    {{ item.item.name }}
                  </span>
                </td>
                <td>
                  {{ item.item.priceNetto }}
                </td>
                <td>
                  {{ item.item.priceBrutto }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="item.packagePromotions.length > 0">
            <h6>
              <i class="fa fa-percent"></i>
              {{$t('views.packages.show.promotions')}}:
            </h6>
            <hr class="mb-1 mt-0">
            <ul>
              <li v-for="item in item.packagePromotions" :key="item['@id']">
                {{ item.promotion.title }}
              </li>
            </ul>
          </div>
          <div v-if="item.packageDevices.length > 0">
            <h6>
              <i class="fa fa-print fa-lg"></i>
              {{$t("views.packages.show.packagesDevices")}}
            </h6>
            <hr class="mb-1 mt-0">
            <ul>
              <li v-for="item in item.packageDevices" :key="item['@id']">
                <router-link
                  v-if="ableToViewDevice"
                  :to="{name: 'EXCMDeviceShow', params: {id: item.device['@id']}}">
                  {{ item.device.name }}
                </router-link>
                <span v-else>{{ item.device.name }}</span>
              </li>
            </ul>
          </div>
        </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'

export default {
  name: 'Show',
  components: { Loader },

  data () {
    return {
      paymentsParams: {
        idPackage: getId(this.$route.params.id)
      }
    }
  },

  computed: {
    ...mapGetters({
      item: 'packages/show/getPackage',
      isLoading: 'packages/show/getIsLoadingPackage'
    }),
    ableToViewDevice () {
      return checkPermission('devices', 'EXCMDeviceShow')
    },
    ableToViewItem () {
      return checkPermission('warehouses', 'EXSBItemShow')
    }
  },

  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABPackagesShow')
  },

  created () {
    this.fetchPackage(this.$route.params.id)
  },

  beforeDestroy () {
    this.reset()
  },

  methods: {
    ...mapActions({
      fetchPackage: 'packages/show/fetchPackage'
    }),
    ...mapMutations({
      reset: 'packages/show/reset'
    })
  }
}
</script>

<style scoped>

</style>
